import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateGetManagerList = {
  getManagerList: { data: null, loading: false, error: null },
};

export const getManagerList = createAsyncThunk('user/getManagerList', async (data = {}, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`${process.env.REACT_APP_SERVER_API}/users/`, {
      params: { type: 'staff', role: 'manager', ...data },
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGetManagerList = {
  [getManagerList.pending]: (state) => {
    state.getManagerList.loading = true;
    state.getManagerList.error = null;
  },
  [getManagerList.fulfilled]: (state, action) => {
    state.getManagerList.loading = false;
    state.getManagerList.data = action.payload;
    state.getManagerList.error = null;
  },
  [getManagerList.rejected]: (state, action) => {
    state.getManagerList.loading = false;
    state.getManagerList.error = action.payload;
  },
};
